import { State, Effect, dispatch, Actions } from 'jumpstate'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import axios from 'axios'
import apiAddress from '../utils/APIEndPointAddress'

const HorseshoeState = State({
  initial: {
    tariff: null
  },
  setHorseshoeTariff (status, payload) {
    return {
      tariff: payload
    }
  }
})

// eslint-disable-next-line
const horseshoeTariffEffect = Effect('horseshoeTariff', () => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.get(`${apiAddress}horseshoe/cost-list`).then((res) => {
    Actions.setHorseshoeTariff(res.data)
    return res
  }).catch(e => {
    return Promise.reject(e)
  })
})

// eslint-disable-next-line
const horseshoePayEffect = Effect('horseshoePay', (planId) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.post(`${apiAddress}horseshoe/pay`, {plan_id: planId}).then((res) => {
    return res
  }).catch(e => {
    return Promise.reject(e)
  })
})

export default HorseshoeState



// WEBPACK FOOTER //
// ./src/states/horseshoe.js